import { render, staticRenderFns } from "./mosheng.vue?vue&type=template&id=900a4aca&scoped=true&"
import script from "./mosheng.vue?vue&type=script&lang=js&"
export * from "./mosheng.vue?vue&type=script&lang=js&"
import style0 from "./mosheng.vue?vue&type=style&index=0&id=900a4aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900a4aca",
  null
  
)

export default component.exports